import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import {styled} from '@mui/material/styles';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1rem;
  gap: 1rem;
`;

const Row = styled('div')`
  display: flex;
  padding: ${SIZES['8']} 0;
`;

const FooterLink = styled('a')`
  text-decoration: none;
  cursor: pointer;
  padding-top: ${SIZES['8']};
`;

const ExternalLink = styled(FooterLink)`
  margin-right: ${SIZES['16']};
  padding: 0;
  &:last-child {
    margin-right: 0;
  }
`;

const WhiteTypography: any = styled(Typography)`
  &&& {
    color: ${COLORS.white};
  }
`;

export {Container, Row, FooterLink, ExternalLink, WhiteTypography};
